import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, unref as _unref, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "q-px-md q-py-md text-off-black" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { useDialogPluginComponent } from 'quasar';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleDialog',
  props: {
    dismissText: { default: 'Close' },
    list: { default: () => [] },
    message: { default: '' },
    okColor: { default: 'primary' },
    okText: { default: '' },
    prompt: { type: Boolean, default: false },
    title: null,
    type: { default: 'neutral' }
  },
  setup(__props: any) {



const { dialogRef, onDialogOK } = useDialogPluginComponent();

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "q-dialog__title q-pa-none" }, {
            default: _withCtx(() => [
              _createElementVNode("div", {
                class: _normalizeClass(["q-py-sm q-px-md text-white", {
            'bg-primary': __props.type === 'neutral',
            'bg-positive': __props.type === 'positive',
            'bg-negative': __props.type === 'negative',
          }])
              }, _toDisplayString(__props.title), 3)
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            (__props.message)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(__props.message), 1))
              : _createCommentVNode("", true),
            (__props.list)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(item), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_q_card_actions, { align: "right" }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, {
                flat: "",
                label: __props.dismissText,
                padding: "xs md"
              }, null, 8, ["label"]), [
                [_directive_close_popup]
              ]),
              (__props.prompt)
                ? _withDirectives((_openBlock(), _createBlock(_component_q_btn, {
                    key: 0,
                    color: __props.okColor,
                    label: __props.okText,
                    onClick: _unref(onDialogOK)
                  }, null, 8, ["color", "label", "onClick"])), [
                    [_directive_close_popup]
                  ])
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})